import { useEffect, useMemo, useState } from 'react';
import { PopupComponents } from '@/components/popup/PopupComponents';
import update_bg1 from '@/assets/icons/guidepopup/update_bg1.png';
import _0057_i from '@/assets/icons/login/_0057_i.png';
import update_coin from '@/assets/icons/guidepopup/update_coin.png';
import Close from '@/assets/icons/guidepopup/Close.png';
import Close1 from '@/assets/icons/guidepopup/Close1.png';
import service_icon from '@/assets/icons/guidepopup/service_icon.png';
import red_tip from '@/assets/icons/guidepopup/red_tip.png';
import {
  downFile,
  isAndroid,
  isIOS,
  isSupportPWA,
  PWA_Installed
} from '@/utils/index';
import classNames from 'classnames';
import { getSpringboard } from '@/api';
import { searchData } from '@/api/interface';
import { useLocation, useSearchParams } from 'react-router-dom';
import qs from 'qs';
import { Mask, Space, Toast } from 'antd-mobile';
import { CheckCircleOutline } from 'antd-mobile-icons';
import { useCommonVisible } from '@/hooks';
import dayjs from 'dayjs';
import ApplePopup from './ApplePopup';
import { getUserInfo } from '@/tools';
import { UAParser } from 'ua-parser-js';
import { formatter } from '@/utils/mathWays';
import { reportParams } from '@/utils/crypto';
import Cookies from 'js-cookie';
import { useActivate } from 'react-activation';
import { getServicoList } from '@/api/servico';

let timerId: any = 0;
const RETRY_COUNT_MAX = 5;
const installTime = 15000;
const installInterval = Math.ceil(installTime / 99);

const step = 1;
const detectTime = 15000;
const detectInterval = Math.ceil(detectTime / 100);

const options = [
  {
    label: 'Tudo Agente Ganhos',
    value: '0'
  },
  {
    label: 'Nível 1 Agente Ganhos',
    value: '1'
  },
  {
    label: 'Nível 2 Agente Ganhos',
    value: '2'
  },
  {
    label: 'Nível 3 Agente Ganhos',
    value: '3'
  }
];
interface ServicoItem {
  id: number;
  avatar?: string; //头像
  account?: string; //跳转地址
  name?: string; //名称
  status?: string; //状态
  type?: string; //客户类型
}

const GuidePopup = ({
  configInfo,
  deferredPrompt,
  setDeferredPrompt,
  detectPercent,
  setDetectPercent
}) => {
  const {
    content,
    presentAmountView,
    interval,
    apple,
    appleLink,
    android,
    apkLink,
    time // 0 访问主页 可立即弹，1：入金后且登录再调接口
  } = configInfo || {};
  const [visible, setVisible] = useState(false);
  const [customerVisible, setCustomerVisible] = useState(false);
  const [isIosPopup, setIsIosPopup] = useState(false);
  const { search } = useLocation();
  const { getToken } = getUserInfo();
  const [searchParams] = useSearchParams();
  const queryParams = search;
  const urlParams = new URLSearchParams(search.split('?')[1]);

  // const [deferredPrompt, setDeferredPrompt] = useState(null) as any;
  // const [detectPercent, setDetectPercent] = useState(0);
  const [precent, setPrecent] = useState(0);
  const [selectedId, setSelectedId] = useState(0);
  const detectDialog = useCommonVisible();
  //   const [installing, setInstalling] = useState(false);

  const isInstalled = useMemo(() => {
    return localStorage.getItem(PWA_Installed);
  }, [localStorage.getItem(PWA_Installed)]);

  useEffect(() => {
    if (detectDialog.visible) {
      timerId = setInterval(() => {
        setDetectPercent(precent => {
          const _precent = Math.floor(precent + step);
          if (_precent >= 100) {
            clearInterval(timerId);
            return 100;
          }
          return _precent;
        });
      }, detectInterval);
    }
  }, [detectDialog.visible]);

  let retryCount = 0;

  const timerFn = () => {
    timerId = setInterval(() => {
      setPrecent(precent => {
        const _precent = Math.floor(precent + step);
        if (_precent >= 99) {
          clearInterval(timerId);
          return 99;
        }
        return _precent;
      });
    }, installInterval);
  };

  const install = () => {
    try {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          //   setInstalling(true);
          timerFn();
          setTimeout(() => {
            clearInterval(timerId);
            setPrecent(100);
            // setInstalling(false);
            localStorage.setItem(PWA_Installed, 'true');
            localStorage.setItem('homeParams', urlParams.toString());
            Cookies.set('homeParams', urlParams.toString());
            setVisible(false);
            // installBanner.close();
          }, installTime);
        } else {
          console.log('---- 取消安装 ----');
          Toast.show('Você cancelou a instalação!');
        }
        // deferredPrompt = null
        setDeferredPrompt(null);
      });
    } catch (error) {
      if (retryCount < RETRY_COUNT_MAX) {
        setTimeout(() => {
          retryCount++;
          console.log('---- 安装失败 - 重试 ----', retryCount);
          install();
        }, 100);
      } else {
        console.log('---- 安装失败 ----', error);
        Toast.show('A instalação falhou!');
      }
    }
  };

  const handleInstall = async () => {
    console.log('进入了handleInstall');
    const parser = new UAParser(navigator.userAgent);
    const browserName = parser.getBrowser().name;
    console.log(browserName);
    if (!(window as any).isChrome() && (window as any).isAndroid()) {
      if (/FBAV|FBAN|FBIOS|FBAN|FB|FACEBOOK/i.test(browserName!)) {
        (window as any).launchChrome();
        return;
      }
    }

    // 如果是非谷歌并且没有配置apk 则多次引导
    if (
      !/Chrome/i.test(browserName!) &&
      [1, 2].includes(+android) &&
      !apkLink
    ) {
      console.log('非谷歌浏览器并且未配置apk');
      (window as any).launchChrome();
      return;
    }

    if (!isSupportPWA()) {
      Toast.show('Seu navegador não suporta pwa');
      // const android_url = import.meta.env.VITE_ANDROID_URL;
      // if (android_url) {
      //   const fileName = android_url.split('/').pop();
      //   downFile(android_url, fileName);
      // } else {
      //   Toast.show('Você não configurou o endereço de download do aplicativo');
      // }
      return;
    }

    if (deferredPrompt) {
      console.log('开始安装');
      install();
      // @ts-ignore
      if (window.trackFn && window.trackName) {
        console.log('判断是否有值CustomizeProduct-安装pwa');
        // @ts-ignore
        window.trackFn(window.trackName['CustomizeProduct'], {
          ...reportParams()
        });
      }
    } else {
      // 如果不具备pwa的安装环境  则弹出加载动画 给出一个较长时间的动画  确定在此动画之后 浏览器具备安装pwa环境
      console.log('环境未准备好');
      detectDialog.open();
    }
  };

  const searchInfo: searchData = useMemo(() => {
    let info = {};
    if (queryParams) {
      info = qs.parse(queryParams.split('?')[1]);
    }
    return info;
  }, [queryParams]);

  // 查询是否弹窗
  const querySpringboard = async () => {
    if (time === 0) {
      // 不论有没有登录，设置为访问主页就直接弹窗，不需要登录和调用是否弹窗接口
      setVisible(true);
      sessionStorage.setItem('openTime', dayjs().toString());
    } else if (time === 1 && getToken()) {
      let params = {};
      if (searchInfo?.ch) {
        params = { ch: searchInfo?.ch };
      }
      const { code, data } = await getSpringboard(params);
      if (code === 200) {
        if (data) {
          sessionStorage.setItem('openTime', dayjs().toString());
        }
        setVisible(data);
      }
    }
  };

  useActivate(() => {
    if (!sessionStorage.getItem('openTime')) {
      querySpringboard();
    } else {
      const openTime = dayjs(sessionStorage.getItem('openTime'));
      const now = dayjs();
      const diff = now.diff(openTime, 'minutes');
      if (interval * 60 <= diff) {
        querySpringboard();
      }
    }

    console.log(
      '%c [ interval ]-254',
      'font-size:13px; background:pink; color:#bf2c9f;',
      interval
    );
    if (interval !== 0) {
      setInterval(() => {
        querySpringboard();
      }, interval * 60 * 60 * 1000);
    }
  });

  useEffect(() => {
    if (!sessionStorage.getItem('openTime')) {
      querySpringboard();
    }
  }, []);
  useEffect(() => {
    if (sessionStorage.getItem('openTime')) {
      const openTime = dayjs(sessionStorage.getItem('openTime'));
      const now = dayjs();
      const diff = now.diff(openTime, 'minutes');
      if (interval * 60 <= diff) {
        querySpringboard();
      }
    }
  }, []);

  useEffect(() => {
    if (interval !== 0) {
      setInterval(() => {
        querySpringboard();
      }, interval * 60 * 60 * 1000);
    }
  }, [interval]);

  const handleInstallApp = () => {
    if (isIOS) {
      switch (apple) {
        case 0: // 添加到桌面
          setIsIosPopup(true);
          break;
        case 1: // 苹果AppStore
          window.open(appleLink);
          break;

        default:
          break;
      }
    } else {
      const fileName = apkLink ? apkLink?.split('/').pop() : '';
      switch (android) {
        case 0: // pwa(快捷安装)
          handleInstall();
          break;
        case 1: // apk(需要自己封装)
          apkLink
            ? downFile(apkLink, fileName)
            : Toast.show('Pacote de download não configurado');
          // @ts-ignore
          if (window.trackFn && window.trackName) {
            console.log('判断是否有值CustomizeProduct');
            // @ts-ignore
            window.trackFn(window.trackName['CustomizeProduct'], {
              ...reportParams()
            });
          }
          break;
        case 2: // pwa(优先)+apk
          if (isSupportPWA()) {
            handleInstall();
          } else {
            apkLink
              ? downFile(apkLink, fileName)
              : Toast.show('Pacote de download não configurado');
            // @ts-ignore
            if (window.trackFn && window.trackName) {
              console.log('判断是否有值CustomizeProduct');
              // @ts-ignore
              window.trackFn(window.trackName['CustomizeProduct'], {
                ...reportParams()
              });
            }
          }
          break;

        default:
          break;
      }
    }
  };

  const handleSelector = (account, type, id) => {
    setSelectedId(id);
    switch (type) {
      case 'Tel':
        window.location.href = `tel:${account}`;
        break;
      case 'Whatsapp':
        window.open(`https://wa.me/${account}`, '_blank');
        break;
      case 'Instagram':
        window.open(`https://instagram.com/${account}`, '_blank');
        break;
      case 'Telegram':
        window.open(`https://t.me/${account}`, '_blank');
        break;
      default:
        window.open(account, '_blank');
        break;
    }
  };
  // 客服列表
  const [ServicoList, setServicoList] = useState<ServicoItem[]>([]);
  const queryUserCount = async () => {
    const { code, data } = await getServicoList();
    if (code === 200) {
      const statusIsOpen = data.filter(item => {
        return item.status == 'Online';
      });

      setServicoList(statusIsOpen);
    }
  };

  return (
    <PopupComponents
      isOpen={visible}
      closeModal={() => {
        interval !== 0 && setVisible(false);
      }}
      direction="BtoT"
      dialogClassName="z-[1000] h-screen"
      classNameStr={classNames(
        'w-full bottom-0  bg-white rounded-t-3xl  pb-6 h-[459px]',
        {
          '!h-[659px]': isAndroid
        }
      )}
    >
      <div className="relative">
        <img src={update_bg1} alt="" />
        {interval !== 0 && (
          <img
            src={Close}
            alt="Close"
            onClick={() => setVisible(false)}
            className="w-7 absolute top-2 right-2 "
          />
        )}
      </div>
      <div className="w-full ">
        <div className="w-full h-full px-4 pb-32 overflow-y-scroll ">
          <div className=" text-center text-[#2F1780] bg-white">
            <h1 className="  font-semibold text-[18px] text-center">
              Descobrir uma nova versão
            </h1>
            <span className=" font-semibold text-[#2F1780] text-[18px]">
              V2.0
            </span>
          </div>
          {content ? (
            <div className="text-[#2F1780] text-[12px] mt-2">
              A sua conta recarga foi recebida. Atualize para o aplicativo e
              aproveite o jogo, ganhando um bônus extra de
              <span className="text-[#FF1241] ml-1 mr-1">R$</span>
              <span className="text-[#FF1241] text-[14px] font-bold">
                {formatter.format(presentAmountView)}
              </span>
            </div>
          ) : (
            <div className="text-[#2F1780] text-sm">
              <div className="flex items-center justify-center">
                <img src={update_coin} alt="" className="w-3 mr-1" />
                <span>Mais jogos adicionados.</span>
              </div>
              <div className="flex items-center justify-center">
                <img src={update_coin} alt="" className="w-3 mr-1" />
                <span>Mais bônus e benefícios distribuídos. </span>
              </div>
              <div className="flex items-center justify-center">
                <img src={update_coin} alt="" className="w-3 mr-1" />
                <span>Interface do sistema e velocidade de </span>
              </div>
              <div className="flex items-center justify-center">
                <span>acesso otimizadas. </span>
              </div>
            </div>
          )}

          {/* <div className="flex items-center justify-start mt-3 bg-black/5 text-sm text-black/85 py-2 px-4 rounded-md">
            <img src={logoUrl} alt={siteName} className="w-8 mr-2 rounded-md" />
            <span>{siteName}</span>
          </div> */}
          <div className="flex items-center justify-center mt-5">
            {isInstalled ? (
              <div
                onClick={() => {
                  window.open(
                    `${location.origin}/${location.search}`,
                    '_blank'
                  );
                }}
                className={`bg-installed flex-1 text-center  text-base flex items-center justify-center   text-[#2F1780] py-2 rounded-[25px]`}
              >
                <span>Abrir o Aplicativo</span>
              </div>
            ) : (
              <div
                onClick={handleInstallApp}
                className={` bg-[#FFDF12] flex-1 text-center  text-base flex items-center justify-center   text-[#2F1780] py-2 rounded-[25px]`}
              >
                <span>Actualizar Agora</span>
              </div>
            )}
            <img
              src={service_icon}
              alt=""
              className="w-11 ml-3 "
              onClick={() => {
                setCustomerVisible(true);
                queryUserCount();
              }}
            />
          </div>
          <div className="text-[#FF1241] mt-2  p-[10px] bg-[#6453FD1A] rounded-[8px]">
            <div className="flex">
              <img src={red_tip} alt="" className="w-6 h-6 mr-2" />
              <span className="inline-block text-[13px] leading-[16px] font-[600]  ">
                Após instalar o APP, volte para a tela inicial e abra o APP para
                usar.
              </span>
            </div>
          </div>
          {/* <div
            onClick={() => {
              setCustomerVisible(true);
              queryUserCount();
            }}
            className={` bg-[#0BCF33] text-center mt-2 text-base flex items-center justify-center   text-[#2F1780] py-2 rounded-xl`}
          >
            <span>Entrar em contato com o suporte</span>
          </div> */}
          {isAndroid ? (
            <div>
              <h4 className="text-[#2F1780] text-[15px] mt-4 font-bold">
                Instalação de um aplicativo Android:
              </h4>
              <ul className="text-[#2F1780] text-[13px] leading-4 mt-2">
                <li>
                  1. Clique no botão acima para baixar o arquivo de instalação
                  para Android.
                </li>
                <li>
                  2. Permita a instalação de aplicativos de fontes desconhecidas
                  nas configuraçóes do seu dispositivo.
                </li>
                <li>3. Conclua a instalacao.</li>
              </ul>
              <div className="text-[#2F1780] mt-2  py-1 px-2 bg-[#2F17800A] rounded-[5px]">
                <div className="flex">
                  <img
                    src={_0057_i}
                    alt=""
                    className="w-[18px] h-[18px] mr-2"
                  />
                  <span className="inline-block text-[13px] leading-[18px]  ">
                    Este aplicativo passou pela certificacao de seguranca do
                    GooglePlay, sinta-se a vontade para reallzar a instalação.
                  </span>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <ApplePopup isOpen={isIosPopup} closeModal={setIsIosPopup} />
      <Mask visible={detectDialog.visible}>
        <div className="p-[20px] bg-[#2F1780]/90 rounded-[10px] absolute left-[20px] right-[20px] text-center top-0 bottom-0 m-auto h-[160px] flex items-center flex-col justify-evenly border-[2px] border-[#FFDF12]">
          <div className="font-semibold text-[18px] w-full">
            {detectPercent === 100 ? (
              <Space align="center">
                <CheckCircleOutline fontSize={20} color="#0BCF33" />
                <span className="text-[#FFFFFF] text-[14px]">
                  Detecção bem-sucedida
                </span>
              </Space>
            ) : (
              // '正在检测安装环境...'
              <span className="text-[#FFFFFF] text-[14px]">
                Detecção do ambiente de instalação...
              </span>
            )}
          </div>

          {detectPercent === 100 ? (
            <div
              onClick={() => {
                detectDialog.close();
                setTimeout(() => {
                  // 延后判断 确保触发beforeinstallprompt事件
                  console.log('deferredPrompt22', deferredPrompt);
                  console.log('configInfo22', configInfo);
                  if (deferredPrompt) {
                    if (configInfo) {
                      handleInstallApp();
                    } else {
                      handleInstall();
                    }
                  } else {
                    if (configInfo.apkLink) {
                      const fileName = configInfo.apkLink.split('/').pop();
                      downFile(configInfo.apkLink, fileName);
                    } else {
                      Toast.show(
                        'Você não configurou o endereço de download do aplicativo'
                      );
                    }
                  }
                }, 300);
              }}
              className={`text-center w-full h-[40px] text-[#2F1780] leading-[40px] rounded-[5px] bg-[#FFDF12]`}
            >
              Install Now
            </div>
          ) : (
            <div className="w-[60px] h-[60px] text-[#FFFFFF] detectDialog relative mt-[20px] mb-[20px] leading-[60px] m-auto">
              {detectPercent}%
            </div>
          )}
        </div>
      </Mask>

      <Mask visible={precent > 0 && precent < 100}>
        <div className="p-[20px] bg-[#2F1780]/90 rounded-[10px] absolute left-[20px] right-[20px] text-center top-0 bottom-0 m-auto h-[160px] flex items-center flex-col justify-evenly border-[2px] border-[#FFDF12]">
          <div className="font-semibold w-full  text-[#FFFFFF] text-[14px]">
            Em instalação
          </div>

          <div className="w-[60px] h-[60px] text-[#FFFFFF] detectDialog relative mt-[20px] mb-[20px] leading-[60px] m-auto">
            {precent}%
          </div>
        </div>
      </Mask>
      <Mask
        visible={customerVisible}
        onMaskClick={() => setCustomerVisible(false)}
      >
        <div
          className="bg-[#2F1780] rounded-[10px] absolute bottom-0 w-full h-[400px] flex flex-col"
          onClick={e => e.stopPropagation()}
        >
          <div className="font-semibold w-full relative text-center leading-[44px] text-[#FFFFFF] h-[44px] text-[14px] bg-[#6453FD]/70 rounded-t-[10px]">
            Entrar em contato com o suporte
            <img
              src={Close1}
              alt="Close"
              onClick={() => setCustomerVisible(false)}
              className="w-[24px] h-[24px] absolute top-2 right-2 "
            />
          </div>
          <div
            className="px-5 mt-5"
            style={{ height: 'calc(100% - 44px)', overflowY: 'scroll' }}
          >
            <p className="text-[#fff] text-[15px] my-[15px] ">
              Selecionar canal
            </p>
            <div className="rounded-lg  text-[#FFFFFFBF] ">
              {ServicoList.map(({ id, avatar, name, account, type }) => (
                <div
                  key={id}
                  onClick={() => handleSelector(account, type, id)}
                  className={`flex items-center p-3 bg-[#6453FD]/20 mb-4 rounded-lg cursor-pointer ${
                    selectedId === id ? 'bg-[#6453FD]/40' : ''
                  }`}
                >
                  <img src={avatar} alt="" className="w-6 h-6 mr-3" />
                  <span>{name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Mask>
    </PopupComponents>
  );
};

export default GuidePopup;
